import {store} from '../index';

export default class ApiHelper {
    static appSettings;  
}

export const API_ACTION_MACHINESBYMACHINETYPE = "Machine/GetByMachineTypeId";
export const API_ACTION_MACHINESWITHSCISSORSTATUSINFO = "Machine/GetMachinesWithScissorStatusInfo";
export const API_ACTION_PRODUCTIONORDERSBYMACHINE = "ProductionOrder/GetByMachineId";
export const API_ACTION_PRODUCTIONORDERSBYSEARCHTEXT = "ProductionOrder/GetBySearchText";
export const API_ACTION_ORDERDETAILS = "ProductionOrder/GetOrderDetailsByOrderId";
export const API_ACTION_SYTEMPARAMETER = "SystemParameter/";
export const API_ACTION_ASSIGNQUANTITYATMACHINE = "MachineInAssigned/AssignQuantityAtMachine";
export const API_ACTION_GETMACHINEINASSIGNEDBYMACHINEID = "MachineInAssigned/GetByMachineId";
export const API_ACTION_DELETEMACHINEINASSIGNEDBYID = "MachineInAssigned/";
export const API_ACTION_UPDATEZONES = "ProductionOrderBOW/UpdateZones";
export const API_ACTION_STARTPRODUCTIONORDER = "ProductionOrderLogic/StartProductionOrder";
export const API_ACTION_PAUSEPRODUCTIONORDER = "ProductionOrderLogic/PauseProductionOrder";
export const API_ACTION_STOPPRODUCTIONORDER = "ProductionOrderLogic/StopProductionOrder";
export const API_ACTION_FINISHPRODUCTIONORDER = "ProductionOrderLogic/FinishProductionOrder";
export const API_ACTION_GETPRODUCTIONORDERLINEBOMOUTPRODUCED = "ProductionOrderLineBOMOutProduced/GetByBOMOutId";
export const API_ACTION_CREATEBOOKING = "ProductionOrderLogic/CreateBookingForProductionOrder"
export const API_ACTION_GETMACHINESETTINGSBYMACHINEID = "MachineSetting/GetMachineSettingsByMachineId";
export const API_ACTION_SAVEMACHINESETTINGS = "MachineSettingLogic/SaveMachineSettings";
export const API_ACTION_GETQUALITYSAMPLESBYBARCODE = "QualitySampleLogic/GetQualitySamplesByBarcode";
export const API_ACTION_SAVEQUALITYSAMPLES = "QualitySampleLogic/SaveQualitySamples";
export const API_ACTION_GETQUALITYSAMPLESBYPRODUCTIONORDER = "QualitySampleLogic/GetQualitySampleValuesByProductionOrderId";
export const API_ACTION_MACHINESTOPPEDREASON = "Machine/MachineStoppedReason";
export const API_ACTION_SAVENOTIFICATION = "Notification/";
export const API_ACTION_GETLATESTNOTIFICATIONS = "Notification/GetLatestNotifications";
export const API_ACTION_GETCHECKNUMBERFORPALLET = "QualitySampleValue/GetCheckNumberForPallet";
export const API_ACTION_SAVEVISITORREGISTRATION = "VisitorRegistrationLogic/SaveVisitorRegistration";
export const API_ACTION_UPDATEPRODUCTIONORDERMETADATA = "ProductionOrderLogic/UpdateProductionOrderMetaData";

export function ComposeUri(action){
    return ApiHelper.appSettings.SMARTFACTORY_SHOPFLOOR_API_BASE_URL + action;
}

export function getAuthHeader(){
    var state = store.getState();
    var token = state.user.userToken;

    return token ? 'Bearer ' + token : ''; 
}